import { FocusSDK } from "@/utils";
import React from "react";

interface IState {
  hasError: boolean;
}
type IProps = Readonly<{}>;

class ErrorComp extends React.Component<IProps, IState> {
  static getDerivedStateFromError(error: any) {
    console.log(`ErrorBoundary`, error);
    // 重新加载
    return { hasError: true };
  }

  constructor(props: IProps) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error: any, info: any) {
    console.log(`ErrorBoundary`, error, info);
    // FocusSDK.printLog(`ErrorBoundary`, JSON.stringify({ error, info }));
  }

  render() {
    if (this.state.hasError) {
      // 你可以自定义降级后的 UI 并渲染
      return <span>稍后重试</span>;
    }
    return this.props.children;
  }
}
export default ErrorComp;
